<template>
    <div class="interview">

        <el-dialog title="添加线索任务" :visible.sync="isShow" width="500px" :close-on-click-modal="false" center>
            <el-form label-width="120px" :model="addForm" ref="addForm" :rules="rules">
                <el-form-item label="线索编号" prop="interviewName">
                    <el-input v-model="addForm.workerNo" disabled></el-input>
                </el-form-item>
                <el-form-item label="线索名称">
                    <el-input v-model="tempRow.workerName" disabled></el-input>
                </el-form-item>

                <el-form-item label="跟进日期" prop="followupTime">
                    <el-date-picker v-model="addForm.followupTime" type="datetime" format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"   placeholder="选择日期"></el-date-picker>
                </el-form-item>

                <el-form-item label="任务内容" prop="content">
                    <el-input type="textarea" rows="6" v-model="addForm.content" placeholder="请输入跟进内容"
                        clearable></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShow = false">关闭</el-button>
                <el-button type="primary" @click="saveCreate">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { regionData, regionDataPlus } from "element-china-area-data";
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import taskApi from "@/script/api/taskApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import {
    validatePhoneTwo,
    validateIdNo,
    validateIdNotmust,
    validateIdNoOrNull,
    validateNumber,
} from "@/script/validator";

let vm;
export default {
    data() {
        return {
            isShow: false,
            tempRow: {},
            addForm: {
                workerNo: '',
                rNo: '',
                followupTime: '',
                content:'',
                // handleId:'',
                // handleName:'',
                taskType: 1,
                operUserId: ''
            },
            rules: {
                interviewName: [
                    {
                        required: true,
                        message: "输入面试名称",
                        trigger: "change",
                    },
                ],

            },
        };
    },
    beforeCreate() {
        vm = this;
    },
    methods: {
        showAdd(row) {
            this.tempRow = row;
            this.isShow = true;
            this.addForm = {
                workerNo: row.workerNo,
                rno: row.workerNo,
                followupTime: '',
                content:'',
                taskType: 1,
                operUserId: globalData.userInfo.id
            };
        },
        saveCreate() {
            if(this.addForm.followupTime==''){
                this.$message.error("请选择跟进时间");
                return;
            }
            taskApi.$axioCreateTask(this.addForm).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("添加成功");
                    this.isShow = false;
                    this.$parent.querySearch();
                }
            });
        }

    },
};
</script>
<style scoped></style>
